import React from 'react';
import { AvvisoInLista, AvvisoNonInApp } from './AvvisoInLista';

/*
 * Corso fuori date (14/10/2026): la data di fine e' passata, quindi il corso non si vede piu' nell'app e non si
 * acquista, anche se e' «Attivo». Stessa regola del backend (booking-service, utils/corso-terminato.ts): la data
 * di fine e' l'ultimo giorno buono, il giorno e' quello italiano, senza data di fine il corso non scade.
 */

const oggiInItalia = () =>
    new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());

const fineDelCorso = (corso) => (corso?.endDate ? String(corso.endDate).slice(0, 10) : '');

export const corsoFuoriDate = (corso, oggi = oggiInItalia()) => {
    const fine = fineDelCorso(corso);
    return !!fine && fine < oggi;
};

const dataItaliana = (giorno) => {
    const [a, m, g] = String(giorno).split('-');
    return g && m && a ? `${g}/${m}/${a}` : giorno;
};

/**
 * Triangolino accanto al nome del corso, con la spiegazione al passaggio del mouse. Un corso in date ce l'ha
 * solo se e' «non pubblicato in app» (TASK #9): il triangolino e' sempre uno.
 */
export const AvvisoCorsoFuoriDate = ({ corso }) => {
    if (!corsoFuoriDate(corso)) return <AvvisoNonInApp prodotto={corso} />;
    const testo = `Le date del corso sono nel passato (è finito il ${dataItaliana(fineDelCorso(corso))}): il corso non si vede nell'app e non si può acquistare.`;
    return <AvvisoInLista testo={testo} />;
};

export default AvvisoCorsoFuoriDate;
